module.exports = __webpack_public_path__ + "assets/img/closeIcon.2db7453b.svg";